module.exports = __webpack_public_path__ + "img/madrid.b157fe1e.jpg";